import { Fade, Paper } from "@material-ui/core";
import { Fragment, useContext, useEffect, useState } from "react";
import { AuthContext } from "../../context/context";
import { endoso } from "../../services";
import { AlertModal, SnackBar, Spinner } from "../../shared/components";
import ChartSection from "./sections/chartSection";
import FormSection from "./sections/formSection";
import TableSections from "./sections/tableSections";
import useStyles from "./styles";

const DashBoard = () => {
  const classes = useStyles();
  const {
    token,
    firstLoad,
    setFirstLoad,
    setTimer,
    setBackupSuplement,
    setOnlyApprove,
    setPersons,
  } = useContext(AuthContext);
  const [endosos, setEndosos] = useState([]);
  const [controlPage, setControlPage] = useState({
    size: 0,
    page: 0,
    totalPages: 0,
  });
  const [ramos, setRamos] = useState([]);
  const [oficinas, setOficinas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadTable, setLoadTable] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const [message, setMessage] = useState({});
  const isMobile = window.innerWidth < 960;

  useEffect(() => {
    setPersons([]);
    setBackupSuplement(0);
    setOnlyApprove([]);
  }, []); // eslint-disable-line

  const products = [
    {
      name: "Motor",
      value: endosos.filter((endoso) => endoso.producto === "AUTOS").length,
    },
    {
      name: "Personas",
      value: endosos.filter((endoso) => endoso.producto === "PERSONAS").length,
    },
    {
      name: "Daños",
      value: endosos.filter((endoso) => endoso.producto === "DANIOS").length,
    },
  ];
  const activities = [
    {
      name: "Pendientes",
      value: endosos.filter((solicitud) => solicitud.estatus === "W").length,
    },
    {
      name: "Terminadas",
      value: endosos.filter((solicitud) => solicitud.estatus === "M").length,
    },
  ];
  /* methods */
  const getData = async () => {
    setLoadTable(true);

    const bodyCM = {
      noSolicitud: null,
      oficina: null,
      pagina: 1,
      poliza: null,
      ramo: null,
      registros: null,
      status: "CM",
      tipoEndoso: null,
      usuario: token.cdUsuario,
    };

    const bodyW = {
      noSolicitud: null,
      oficina: null,
      pagina: null,
      poliza: null,
      ramo: null,
      registros: null,
      status: "W",
      tipoEndoso: null,
      usuario: token.cdUsuario,
    };

    try {
      const [endososCM, endososW, ramosResponse, oficinasResponse] =
        await Promise.all([
          endoso.list(null, token.cdUsuario, bodyCM),
          endoso.list(null, token.cdUsuario, bodyW),
          endoso.getRamo(),
          endoso.getOficce(),
        ]);

      if (endososW.data?.solicitudes?.length > 0) {
        setBackupSuplement(endososW.data?.solicitudes[0].suplemLogico);
      }

      setControlPage({
        size: endososCM.data?.cantidad,
        page: 1,
        totalPages: endososCM.data?.cantidad / (isMobile ? 2 : 5),
      });

      setEndosos([
        ...(endososCM.data?.solicitudes ?? []),
        ...(endososW.data?.solicitudes ?? []),
      ]);

      setRamos(ramosResponse.data?.ramos || []);
      setOficinas(oficinasResponse.data?.oficinas || []);
    } catch (error) {
      console.error("Error al obtener los datos:", error);
    } finally {
      setLoading(false);
      setLoadTable(false);
    }
  };

  const showAlert = () => {
    const numberOfPending = endosos.filter(
      (solicitud) => solicitud.estatus === "W"
    ).length;

    if (numberOfPending > 0 && firstLoad) return true;
    return false;
  };

  useEffect(() => {
    getData();
  }, []); // eslint-disable-line

  const terminadas = endosos.filter(
    (s) => s.estatus === "M" || s.estatus === "C"
  );

  const esperaRespuesta = endosos.filter(
    (s) =>
      s.estatus === "W" && s.formaAseguramiento === "002" && s.tipoEndoso === 14
  );

  const pendientes = endosos.filter(
    (s) => !terminadas.includes(s) && !esperaRespuesta.includes(s)
  );

  if (loading) {
    return <Spinner />;
  } else
    return (
      <Fragment>
        <div></div>
        <SnackBar
          HandleShow={setShowMessage}
          show={showMessage}
          severity={message.severity}
          text={message.text}
          time={message.time ?? 15000}
          action={message.action}
        />
        <Fade in={!loading} timeout={600}>
          <div className={classes.root}>
            <Paper elevation={3} className={classes.tables}>
              <TableSections
                title="Actividades pendientes"
                setMessage={setMessage}
                setShowMessage={setShowMessage}
                rows={pendientes}
                type={1}
              />
              <TableSections
                title="Actividades recientes"
                setMessage={setMessage}
                setShowMessage={setShowMessage}
                rows={terminadas}
                type={1}
                controlPage={controlPage}
                setControlPage={setControlPage}
                loadTable={loadTable}
              />
              <TableSections
                title="Espera de respuesta"
                setMessage={setMessage}
                setShowMessage={setShowMessage}
                rows={esperaRespuesta}
                type={1}
              />
            </Paper>
            <div className={classes.sections}>
              <div className={classes.subSectionRight}>
                <ChartSection products={products} activities={activities} />
              </div>
              <div className={classes.subSectionRight}>
                <FormSection
                  ramos={ramos}
                  oficinas={oficinas}
                  setMessage={setMessage}
                  setShowMessage={setShowMessage}
                />
              </div>
            </div>
          </div>
        </Fade>
        <AlertModal
          open={showAlert()}
          close={() => {
            setFirstLoad(false);
          }}
          SuccessText={"Continuar"}
          message="Cuentas con endosos pendientes que deben ser confirmados, recuerda concluirlos o cancelarlos. De otro modo los procesos automáticos los estarían cancelando, debiendo iniciar nuevamente el endoso."
          title={"Atención"}
          success={() => {
            setTimer(0);
            setFirstLoad(false);
          }}
          type={2}
        />
      </Fragment>
    );
};

export default DashBoard;
